/**
 * Persistent meta-progression: which beys have won a tournament, how many
 * championships in total, and whether hard mode is unlocked. Pure data + pure
 * transitions; the localStorage read/write wrapper lives in storage.ts.
 */
export interface Progress {
  /** Bey ids (frame id, or 'custom') that have each won at least one title. */
  championIds: string[];
  /** Total tournaments won. */
  tournamentsWon: number;
  /** Hard mode ("Champion's Gauntlet") unlocked after the first title. */
  hardUnlocked: boolean;
}

export const emptyProgress = (): Progress => ({
  championIds: [],
  tournamentsWon: 0,
  hardUnlocked: false,
});

/** Record a tournament win for `playerId`, returning the new progress. */
export function recordChampionship(p: Progress, playerId: string): Progress {
  const championIds = p.championIds.includes(playerId)
    ? p.championIds
    : [...p.championIds, playerId];
  return {
    championIds,
    tournamentsWon: p.tournamentsWon + 1,
    hardUnlocked: true,
  };
}

/** Tolerant normaliser for whatever shape came out of storage. */
export function normalizeProgress(raw: unknown): Progress {
  const p = (raw ?? {}) as Partial<Progress>;
  return {
    championIds: Array.isArray(p.championIds) ? p.championIds.filter((x) => typeof x === 'string') : [],
    tournamentsWon: typeof p.tournamentsWon === 'number' && p.tournamentsWon >= 0 ? p.tournamentsWon : 0,
    hardUnlocked: p.hardUnlocked === true,
  };
}
